import { render, staticRenderFns } from "./FlexiquoteModuleListSideMenu.vue?vue&type=template&id=3762ba30"
import script from "./FlexiquoteModuleListSideMenu.vue?vue&type=script&lang=js"
export * from "./FlexiquoteModuleListSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports